






























import { Vue, Component } from "vue-property-decorator";
import click2Top from "@/common/directives/click2Top";
import { namespace } from "vuex-class";

const menuStore = namespace("MenuStore");

@Component({
  name: "QFooter",
  directives: {
    click2Top,
  },
})
export default class QFooter extends Vue {
  @menuStore.Getter
  isShowRanking!: boolean;
}
